<template>
  <div>
    <h1>{{ $t('resources.title') }}</h1>
    <p>La Wallonie met plusieurs types de ressources à votre disposition pour vous aider tout au long de la transformation numérique de votre entreprise :</p>
    <ul>
      <li>De l'inspiration et de l'idéation</li>
      <li>Des audits approfondis</li>
      <li>De l'accompagnement et de la formation</li>
      <li>Un annuaire de prestataires</li>
    </ul>
    <p>Retrouvez toutes les informations sur la plateforme Digital Wallonia</p>
    <a href="https://www.digitalwallonia.be/">https://www.digitalwallonia.be/</a>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    print: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      height: 380,
      playerReady: false,
    };
  },
  methods: {
    onReady() {
      this.playerReady = true;
    },
    play() {
      this.$refs.player.play();
    },
    stop() {
      this.$refs.player.stop();
    },
  },
};

</script>

<style scoped>
.c-article-page ol li ul {
  margin: 0;
}
.c-article-page ol li ul li {
  list-style-type: none;
}
table {
  width: 100%;
  margin: 1em 0;
}
table td {
  border: 1px solid #dedede;
  padding: .5em;
}
table th {
  border-bottom: 1px solid #ccc;
  padding: .5em;
  text-align: left;
  font-weight: bold;
}
table td.mobile-title {
  font-weight: bold;
  display: none;
}
@media only screen and (max-width: 1024px) {
  table td.mobile-title {
    display: block;
  }
  table th {
    display: none;
  }
  table td {
    width: 100%;
    float: left;
  }
}
</style>
